import { render, staticRenderFns } from "./rentalList.vue?vue&type=template&id=628fb142&scoped=true&"
import script from "./rentalList.vue?vue&type=script&lang=js&"
export * from "./rentalList.vue?vue&type=script&lang=js&"
import style0 from "./rentalList.vue?vue&type=style&index=0&id=628fb142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fb142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VForm,VIcon,VSelect,VSimpleTable})
